
fourToldApp.controller("rekognitionCntrl", function ($sce, $scope, $window, services, esb, cryptool, $location, $sessionStorage, theme, $rootScope) {
    $scope.url = "https://rekognition-dev.holaprestamo.com.co/"
    $scope.url = $sce.trustAsResourceUrl($scope.url);
    $scope.theme = theme.getTheme();
    $scope.isWorking = false; 
    $scope.data = JSON.parse($window.localStorage.getItem("metadataObj"));

    var iframeholder = document.getElementById("rekognitionIframe")
    
    iframeholder.onload = () => {
        $scope.isWorking = false;
    }
    let isProcessing = false;
    $window.addEventListener('message', function (e) {
        if (!isProcessing && e.data != "success-logout-menu" && e.data != "logout" && e.data != "success-logout" && !e.data.type) {
            isProcessing = true;
            console.log("Borrower: Message recived from rekognition");
            var dataResult = JSON.parse(atob(e.data))
            if (dataResult.ReferenceImage) {
                var iframes = document.querySelectorAll('iframe');
                for (var i = 0; i < iframes.length; i++) {
                    iframes[i].parentNode.removeChild(iframes[i]);
                }
                console.log("sending data...");
                $sessionStorage.dataResult = e.data;
                upload(dataResult)
            } else {
                var iframes = document.querySelectorAll('iframe');
                for (var i = 0; i < iframes.length; i++) {
                    iframes[i].parentNode.removeChild(iframes[i]);
                }
                $scope.$apply(() => {
                    $location.path("/dashboard");
                })
            }
        }
    });
    
    function base64ToBlob(base64, mime) { 
        const byteChars = atob(base64); 
        const byteNumbers = new Array(byteChars.length); 
        for (let i = 0; i < byteChars.length; i++) 
            { 
                byteNumbers[i] = byteChars.charCodeAt(i); 
            } 
        const byteArray = new Uint8Array(byteNumbers); 
        return new Blob([byteArray], { type: mime }); 
    }

    async function upload(dataResult) {
        document.getElementById('iframeholder').innerHTML = ""
        const mimeType = "image/png"
        const data = dataResult.ReferenceImage.Bytes 
        const imageBlob = base64ToBlob(data, mimeType)
        $scope.uploaPicture(imageBlob)
    }
    $scope.cancelTest = () => {
        $sessionStorage.dataResult = undefined
        $location.path("/dashboard");
    }

    $scope.uploaPicture = function (blob) {
        const payload = new FormData();
        $scope.format = blob.type.split("/");
        var type = $scope.data.constraints.fileType || "rekognition";
        payload.append('type', type);
        payload.append('fileExtension', "png");
        payload.append('latitude', $scope.latitude);
        payload.append('longitude', $scope.longitude);
        payload.append('file', blob, 'filename.png');

        services.user.userServices('bearer ' + $window.localStorage.getItem('access_token1')).uploadReceipt({}, payload, function (response, event) {
            if (response.data.url) {
                console.log("userServices data: " + $sessionStorage.dataResult)
                var dataResult = JSON.parse(atob($sessionStorage.dataResult))
                dataResult.ReferenceImage = esb + "/security" + response.data.url
                $sessionStorage.dataResult = btoa(JSON.stringify(dataResult))
                $location.path("/dashboard");

            }
        });
    }
});